/* eslint-disable */
// import TweenMax from 'TweenMax';
import ScrollMagic from 'ScrollMagic';
// import 'animation.gsap';
// import 'debug.addIndicators';

export default {
  init() {

		/* 
		* Smooth scroll on pageload to anchor link
		*/

		if(window.location.hash) {
			var hash = window.location.hash;
		
			$('html, body').animate({
				scrollTop: $(hash).offset().top
			}, 1500, 'swing');
		}

		var controller = new ScrollMagic.Controller();

    // create a scene
    new ScrollMagic.Scene({
        duration: 0,	// the scene should last for a scroll distance of 100px
        offset: 100,	// start this scene after scrolling for 50px
      })
      // .setPin('.scroll-menu-wrapper') // pins the element for the the scene's duration
      .setClassToggle('.nav-primary', 'scroll-active')
      .reverse(true)
      .addTo(controller); // assign the scene to the controller
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js